define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "./topicCopyResponseSearchTopicView",
  "modules/shared/topicSelector/topicSelectorModule",
], function (
  Marionette,
  Backbone,
  Messenger,
  TopicCopyResponseSearchTopicView,
  TopicSelectorModule,
) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicSelector";
      this.namespace = options.namespace;
      this.region = options.region;
    },
    show: function (dataBundle) {
      this.currentConversation = dataBundle.conversation;
      this.conversation = this.currentConversation;
      this.layout = new TopicCopyResponseSearchTopicView.searchTopicView();
      this.searchBar = this.addSubModule(
        new TopicSelectorModule({ region: this.layout.searchBar }),
      );

      this.layout.on("show", this._showSubViews, this);
      this.searchBar.on("topic:search:selected", this._topicSearchSelected, this);
      this.showRegion(this.layout);
    },
    setSelectedConversation: function (conversation) {
      this.selectedConversation = conversation;
    },
    getConversation: function () {
      let conversation;
      switch (this.layout.getRadioValue()) {
        case "current":
          conversation = this.currentConversation;
          break;
        case "search":
          conversation = this.selectedConversation || this.currentConversation;
          break;
        default:
          conversation = this.currentConversation;
          console.log("Unable to detect option selected, assigning topic to current one");
      }
      return conversation;
    },
    noTopicSelectedCheck: function () {
      return (
        this.layout.getRadioValue() === "search" &&
        this.currentConversation === this.getConversation()
      );
    },
    showError: function () {
      this.layout.showError();
    },
    hideError: function () {
      this.layout.hideError();
    },
    _showSubViews: function () {
      this.searchBar.show();
    },
    _topicSearchSelected: function (topic) {
      topic.conversation().onSynced(() => {
        this.selectedConversation = topic.conversation();
        this.hideError();
      });
    },
  });
});
